const config = {
  delay: 200,
  classNames: {
    overlay: 'overlay',
  },
};

export default config;
